import { render, staticRenderFns } from "./GlobalProcessProperties.vue?vue&type=template&id=2273fb66&scoped=true"
import script from "./GlobalProcessProperties.vue?vue&type=script&lang=js"
export * from "./GlobalProcessProperties.vue?vue&type=script&lang=js"
import style0 from "./GlobalProcessProperties.vue?vue&type=style&index=0&id=2273fb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273fb66",
  null
  
)

export default component.exports